export async function carregarLogoRelatorio() {
  try {
    const response = await fetch('/ClimoraX_vertical.png');
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const blob = await response.blob();
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(new Error('Não foi possível ler a logo.'));
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.warn('[Relatório] relatório sem logo', error.message);
    return null;
  }
}

export function criarCabecalhoRelatorio(tituloRelatorio, contexto, logo, geradoEm = new Date()) {
  return {
    columns: [
      ...(logo ? [{ image: logo, width: 55, height: 55, margin: [0, 0, 10, 0] }] : []),
      {
        stack: [
          { text: tituloRelatorio, fontSize: 11, bold: true, color: '#003B73' },
          { text: `${contexto.propriedade} — ${contexto.area}`, fontSize: 14, bold: true, color: '#1976d2', margin: [0, 2, 0, 2] },
          { text: `Gerado em ${geradoEm.toLocaleString('pt-BR')}`, fontSize: 7, color: '#777777' },
        ],
        margin: [0, 4, 0, 0],
      },
    ],
    margin: [0, 0, 0, 12],
  };
}

export function criarDocumentoRelatorio(content, geradoEm = new Date()) {
  return {
    pageSize: 'A4',
    pageMargins: [28, 20, 28, 32],
    defaultStyle: { font: 'Roboto', fontSize: 9, color: '#333333' },
    content,
    footer: (currentPage, pageCount) => ({
      columns: [
        { text: `Página ${currentPage} de ${pageCount}`, fontSize: 7, color: '#777777', margin: [28, 8, 0, 0] },
        { text: `ClimoraX • ${geradoEm.toLocaleDateString('pt-BR')}`, fontSize: 7, color: '#1976d2', bold: true, alignment: 'right', margin: [0, 8, 28, 0] },
      ],
    }),
  };
}

export function criarTabelaRelatorio(linhas, cabecalho = false) {
  return {
    table: {
      headerRows: cabecalho ? 1 : 0,
      widths: linhas[0].map(() => '*'),
      body: linhas.map((linha, indice) => linha.map(text => ({
        text: String(text),
        bold: cabecalho && indice === 0,
        fillColor: indice % 2 === 0 ? '#F5F9FF' : '#FFFFFF',
        margin: [5, 4, 5, 4],
      }))),
    },
    layout: 'noBorders',
    margin: [0, 4, 0, 8],
  };
}
